//@flow
import { Formik } from 'formik';
import _ from 'lodash';
import * as React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connect from 'react-redux/es/connect/connect';
import Switch from 'react-switch';
import * as Yup from 'yup';
import FormSelectInput from '../../components/Inputs/FormSelectInput';
import SelectInput from '../../components/Inputs/SelectInput';
import Toast from '../../components/Toasts/Toast';
import { objectsConstants } from '../../constants/objects.constants';
import {
  isAdmin,
  isAprovador,
  isPontoAtendimento,
  isSudo,
} from '../../helpers/permissions.helper';
import { clienteService } from '../../services/cliente.service';
import { mapaProdutosService } from '../../services/mapaProdutos.service';
import { pedidoEmMapaService } from '../../services/pedidoEmMapa.service';
import { pontoAtendimentoService } from '../../services/pontoAtendimento.service';
import { userService } from '../../services/user.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import CpfInput from '../../components/Inputs/CpfInput';
import { categoriaProdutoService } from '../../services/categoriaProduto.service';
import FormInput from '../../components/Inputs/FormInput';
import { pedidosService } from '../../services/pedidos.service';
import { isValidCPF } from '../../components/Utils/cpfUtils';

const buildValidationSchema = (isSudoFlag, isPontoFlag) => {
  return Yup.object().shape({
    cliente: isSudoFlag
      ? Yup.object()
          .required('Cliente é obrigatório')
          .nullable()
      : Yup.mixed().nullable(),
    pontoAtendimentoId: isPontoFlag
      ? Yup.mixed().nullable()
      : Yup.string()
          .required('PA é obrigatório')
          .nullable(),
    responsavel: Yup.string()
      .nullable()
      .required('Nome do responsável é obrigatório'),
    cpfResponsavel: Yup.string()
      .nullable()
      .required('CPF Obrigatório')
      .test('cpf-valido', 'CPF inválido', (value) => {
        if (!value) return false;
        return isValidCPF(value);
      }),
    produtos: Yup.array()
      .min(1, 'Deve haver ao menos 1 produto no pedido')
      .of(
        Yup.object().shape({
          produto: Yup.object()
            .required('Produto obrigatório')
            .typeError('Produto obrigatório'),
          limiteMaximo: Yup.number()
            .typeError('Limite inválido')
            .min(1, 'Mínimo 1')
            .required(),
          estoqueAtual: Yup.number()
            .typeError('Informe o estoque atual')
            .min(0, 'Não pode ser negativo')
            .required(),
          qtdSolicitar: Yup.number()
            .typeError('Informe a quantidade')
            .when('produto', (produto, schema) => {
              if (produto && produto.bloqueado) {
                return schema.notRequired(); // pula validação
              }
              return schema
                .required('Informe a quantidade')
                .test(
                  'nao-ultrapassa-limite',
                  'Estoque + solicitar não pode ultrapassar limite máximo',
                  function(value) {
                    const { estoqueAtual, limiteMaximo } = this.parent;
                    return (
                      (estoqueAtual || 0) + (value || 0) <= (limiteMaximo || 0)
                    );
                  }
                );
            }),
        })
      ),
  });
};

class PedidoEmMapaEdit extends React.PureComponent<Props> {
  constructor(props) {
    super(props);
    const user = userService.getCurrentUser();
    this.formikRef = React.createRef();
    this.state = {
      entity: {
        produtos: [],
        cliente: isSudo() ? null : user.cliente,
        pontoAtendimentoId: isPontoAtendimento()
          ? user.pontoAtendimento && user.pontoAtendimento.id
          : null,
        atualizou: false,
        urgente: false,
        justificativaRecusa: '',
      },
      categorias: [],
      categoriasSelecionadas: [],
      estoquePorProduto: {},
    };
  }

  componentDidMount() {
    const user = userService.getCurrentUser();
    const id = _.get(this.props.match, 'params.id');

    if (id) {
      this.props.loading(true, 'Verificando estoque...');
      pedidoEmMapaService.doGet(id).then(async (response) => {
        const pedido = response.data;
        if (!pedido) return;

        const mapaResp = await mapaProdutosService.findMapaPedido(
          pedido.pontoAtendimentoId
        );
        const mapa = mapaResp.data || {};

        const pedidoProdutosMap = {};
        (pedido.produtos || []).forEach((p) => {
          const existente = pedidoProdutosMap[p.idProduto];
          if (existente) {
            existente.qtdSolicitar += parseInt(p.qtdSolicitar || 0, 10);
            existente.estoqueAtual += parseInt(p.estoqueAtual || 0, 10);
          } else {
            pedidoProdutosMap[p.idProduto] = {
              qtdSolicitar: parseInt(p.qtdSolicitar || 0, 10),
              estoqueAtual: parseInt(p.estoqueAtual || 0, 10),
            };
          }
        });

        // Produtos do mapa + preenchendo dados do pedido se existir
        const produtos = (mapa.produtos || []).map((item) => {
          const pedidoProd = pedidoProdutosMap[item.idProduto] || {};
          return {
            produto: item.produto,
            idProduto: item.idProduto,
            limiteMaximo: item.limiteMaximo,
            estoqueAtual: parseInt(pedidoProd.estoqueAtual, 10) || 0,
            qtdSolicitar: parseInt(pedidoProd.qtdSolicitar, 10) || 0,
            temEstoque: isPontoAtendimento() ? true : undefined,
            estoqueTotal: isPontoAtendimento() ? null : undefined,
          };
        });

        const codigoDepositante =
          mapa.cliente && mapa.cliente.codigoDepositante;
        const catResp = await categoriaProdutoService.findByCodigoDepositante(
          codigoDepositante
        );
        const categorias = catResp.data || [];

        // Adiciona "Sem categoria"
        categorias.push({
          descricao: 'Sem categoria',
          codigoFamilia: 0,
        });

        const entityAtualizada = {
          id: pedido.id,
          cliente: pedido.cliente || (isSudo() ? null : user.cliente),
          pontoAtendimentoId: pedido.pontoAtendimentoId,
          produtos,
          ativo: pedido.ativo,
          status: pedido.status,
          urgente: pedido.urgente || false,
          responsavel: pedido.responsavel,
          cpfResponsavel: pedido.cpfResponsavel,
          justificativaRecusa: pedido.justificativaRecusa,
        };

        this.setState(
          {
            entity: entityAtualizada,
            categorias,
            categoriasSelecionadas: categorias.map((c) => c.descricao),
            atualizou: true,
          },
          async () => {
            if (
              !isPontoAtendimento() &&
              this.formikRef.current &&
              this.formikRef.current.setFieldValue
            ) {
              const produtosComQtd = entityAtualizada.produtos.filter(
                (p) => p.qtdSolicitar && p.qtdSolicitar > 0
              );

              if (produtosComQtd.length > 0) {
                await this.verificarEstoqueProdutosAsync(
                  produtosComQtd,
                  this.formikRef.current.setFieldValue
                );
              }
            }
            this.props.loading(false);
          }
        );
      });
    } else if (
      isPontoAtendimento() &&
      user.pontoAtendimento &&
      user.pontoAtendimento.id
    ) {
      this.buscarMapaPorPA(user.pontoAtendimento.id);
    } else {
      this.setState({ atualizou: true });
    }
  }

  buscarMapaPorPA = async (idPontoAtendimento) => {
    if (!idPontoAtendimento) return;

    this.props.loading(true, 'Buscando Mapa...');
    console.log('inicio busca');

    try {
      const response = await mapaProdutosService.findMapaPedido(
        idPontoAtendimento
      );
      const mapa = response.data;

      const produtos = (mapa.produtos || []).map((item) => ({
        produto: item.produto,
        idProduto: item.idProduto,
        limiteMaximo: item.limiteMaximo,
        estoqueAtual: 0,
        qtdSolicitar: 0,
        temEstoque: true,
        estoqueTotal: isPontoAtendimento() ? null : undefined,
      }));

      const codigoDepositante = mapa.cliente && mapa.cliente.codigoDepositante;

      const catResp = await categoriaProdutoService.findByCodigoDepositante(
        codigoDepositante
      );
      const categorias = catResp.data || [];

      categorias.push({
        descricao: 'Sem categoria',
        codigoFamilia: 0,
      });

      const categoriasSelecionadas = categorias.map((c) => c.descricao);

      this.setState(
        {
          entity: {
            produtos,
            cliente: {
              codigoCliente: mapa.codigoCliente,
              nomeFantasia: mapa.clienteNomeFantasia,
              label: mapa.cliente.label,
            },
            pontoAtendimentoId: idPontoAtendimento,
            status: mapa.status,
          },
          categorias,
          categoriasSelecionadas,
          atualizou: true,
        },
        async () => {
          // ⏱️ Espera 200ms antes de fechar o loading
          await new Promise((resolve) => setTimeout(resolve, 2000));
          this.props.loading(false);
        }
      );
    } catch (error) {
      console.error('Erro ao buscar mapa do PA:', error);
      this.props.loading(false);
      this.setState((prevState) => ({
        entity: {
          ...prevState.entity,
          produtos: [],
          pontoAtendimentoId: idPontoAtendimento,
          status: null,
        },
        categorias: [],
        categoriasSelecionadas: [],
        atualizou: true,
      }));

      if (this.formikRef.current && this.formikRef.current.setFieldValue) {
        this.formikRef.current.setFieldValue('produtos', []);
        this.formikRef.current.setFieldValue(
          'pontoAtendimentoId',
          idPontoAtendimento
        );
        this.formikRef.current.setFieldValue('status', null);
      }
      this.props.error({
        message: 'Não existe MAPA cadastrado para esse Ponto de Atendimento',
      });
    } finally {
      console.log('finaly');
      //
    }
  };

  componentDidUpdate(prevProps, prevState) {
    console.log('didUp');
    const paMudouECarregouProdutos =
      !isPontoAtendimento() &&
      this.state.entity.produtos.length > 0 &&
      prevState.entity.produtos.length === 0;

    if (paMudouECarregouProdutos) {
      console.log('pa mudou');
      const refAtual = this.formikRef.current;
      if (refAtual && refAtual.setFieldValue) {
        if (!this._verificandoEstoque) {
          this._verificandoEstoque = true;
          // this.props.loading(true);
          // this.props.loading(false);
        }
      }
    } else {
      if (isPontoAtendimento()) {
        this.props.loading(false);
      }
    }
  }

  // verificarEstoqueProdutosAsync = async (produtos, setFieldValue) => {
  //   if (isPontoAtendimento()) {
  //     const atualizados = produtos.map((item) => ({
  //       ...item,
  //       temEstoque: true,
  //       estoqueTotal: null,
  //     }));
  //     setFieldValue('produtos', atualizados);
  //     return;
  //   }

  //   const estoquePorProduto = {}; // cache temporário

  //   // pegar só os produtos únicos com idProduto
  //   const produtosUnicos = _.uniqBy(
  //     produtos.filter((p) => p.idProduto),
  //     'idProduto'
  //   );

  //   for (const item of produtosUnicos) {
  //     try {
  //       const resp = await pedidosService.findEstoque(item.produto);
  //       const estoqueList = resp.data || [];
  //       estoquePorProduto[item.idProduto] = _.sortBy(
  //         estoqueList,
  //         'dataDeValidade'
  //       );
  //     } catch (e) {
  //       console.error(`Erro ao buscar estoque do produto ${item.idProduto}`, e);
  //       estoquePorProduto[item.idProduto] = [];
  //     }

  //     // delay pra não ser bloqueado
  //     // await new Promise((r) => setTimeout(r, 500));
  //   }

  //   const atualizados = produtos.map((itemAntigo) => {
  //     const estoqueList = estoquePorProduto[itemAntigo.idProduto] || [];
  //     const total = _.sumBy(estoqueList, 'quantidadeDisponivel');

  //     return {
  //       ...itemAntigo,
  //       temEstoque: total >= itemAntigo.qtdSolicitar,
  //       estoqueTotal: total,
  //       estoqueAtual: itemAntigo.estoqueAtual,
  //     };
  //   });

  //   this.setState({ atualizados });
  //   setFieldValue('produtos', atualizados);
  // };

  verificarEstoqueProdutosAsync = async (produtos, setFieldValue) => {
    if (isPontoAtendimento()) {
      const atualizados = produtos.map((item) => ({
        ...item,
        temEstoque: true,
        estoqueTotal: null,
      }));
      setFieldValue('produtos', atualizados);
      return;
    }

    try {
      // Envia só os campos necessários
      const payload = produtos
        .filter((p) => p.idProduto && p.qtdSolicitar > 0)
        .map((p) => ({
          idProduto: p.idProduto,
          codigoOmie: p.produto.codigoOmni,
          qtdSolicitar: p.qtdSolicitar,
        }));

      const resp = await pedidosService.verificarEstoqueLote(payload);
      const estoqueMap = _.keyBy(resp.data, 'idProduto');

      const atualizados = produtos.map((item) => {
        const estoqueInfo = estoqueMap[item.idProduto] || {};
        const temEstoque = estoqueInfo.temEstoque || false;
        const estoqueTotal = estoqueInfo.estoqueTotal || 0;

        return {
          ...item,
          temEstoque,
          estoqueTotal,
          qtdSolicitar: temEstoque ? item.qtdSolicitar : 0,
        };
      });
      setFieldValue('produtos', atualizados);
    } catch (error) {
      console.error('Erro ao verificar estoque em lote:', error);
    }
  };

  preencherItensDistribuidos = async (produtos) => {
    const resultado = [];

    for (const item of produtos) {
      const estoques = _.sortBy(
        this.state.estoquePorProduto[item.idProduto] || [],
        'dataDeValidade'
      );
      if (estoques.length === 0) {
        resultado.push({
          idProduto: item.idProduto,
          produto: item.produto,
          quantidade: 0,
          observacoes: 'Sem lote disponível',
          dataDeValidade: null,
          qtdSolicitar: 0,
          estoqueAtual: 0,
          limiteMaximo: item.limiteMaximo,
        });

        continue;
      }

      let qtdRestante = item.qtdSolicitar;

      for (const est of estoques) {
        if (qtdRestante <= 0) break;

        const usar = Math.min(est.quantidadeDisponivel, qtdRestante);
        qtdRestante -= usar;

        resultado.push({
          idProduto: item.idProduto,
          produto: item.produto,
          quantidade: usar,
          observacoes: est.lote,
          dataDeValidade: est.dataDeValidade,
          qtdSolicitar: usar,
          estoqueAtual: item.estoqueAtual,
          limiteMaximo: item.limiteMaximo,
        });
      }

      if (qtdRestante > 0) {
        throw new Error(
          `Produto "${item.produto.descricao}" não possui estoque suficiente`
        );
      }
    }

    return resultado;
  };

  render() {
    const { entity, atualizou } = this.state;
    const isEdit = !!this.state.entity.id;
    const validationSchema = buildValidationSchema(
      isSudo(),
      isPontoAtendimento()
    );
    const isFinalizado =
      (entity.status === 'APROVADO' || entity.status === 'RECUSADO') &&
      !isSudo();

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Pedido em Mapa"
          subTitle=" "
          canBack={true}
        />
        <Formik
          validationSchema={validationSchema}
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={entity}
          enableReinitialize={true}
          innerRef={this.formikRef}
          onSubmit={async (values, actions) => {
            this.props.loading(true, 'Enviando...');
            console.log('Antes de salvar:', values.produtos);
            const statusFinal = values.status;
            const isRecusado = statusFinal === 'RECUSADO';
            const isEdit = !!values.id;

            const produtosComQtdValida = (values.produtos || []).filter((p) => {
              const bloqueado = p.produto && p.produto.bloqueado;
              if (bloqueado) return false;
              const qtd = parseInt(p.qtdSolicitar, 10);
              return !isNaN(qtd) && qtd > 0;
            });

            if (!isRecusado && produtosComQtdValida.length === 0) {
              this.props.loading(false);
              this.props.error({
                message:
                  'Informe ao menos 1 produto com quantidade maior que zero para salvar o pedido.',
              });
              actions.setSubmitting(false);
              return;
            }

            if (!isRecusado && isEdit) {
              const produtosInvalidos = (values.produtos || []).filter((p) => {
                if (isPontoAtendimento()) return false;
                const qtd = parseInt(p.qtdSolicitar, 10) || 0;
                const estoqueTotal = parseInt(p.estoqueTotal, 10) || 0;
                return qtd > estoqueTotal;
              });

              if (produtosInvalidos.length > 0) {
                this.props.loading(false);
                this.props.error({
                  message:
                    'Um ou mais produtos têm quantidade solicitada maior que o estoque.',
                });
                actions.setSubmitting(false);
                return;
              }
              // Bloqueia aprovação com todas as quantidades zeradas
              if (values.status === 'APROVADO') {
                const todasZeradas = (values.produtos || []).every((p) => {
                  const qtd = parseInt(p.qtdSolicitar, 10);
                  return isNaN(qtd) || qtd === 0;
                });

                if (todasZeradas) {
                  this.props.loading(false);
                  this.props.error({
                    message:
                      'Não é possível aprovar o pedido. Todas as quantidades estão zeradas.',
                  });
                  actions.setSubmitting(false);
                  return;
                }
              }
            }

            try {
              const entidade = _.cloneDeep(values);
              entidade.tipoPedido = objectsConstants.TIPO_PEDIDO_EM_MAPA;

              if (!isSudo()) {
                entidade.cliente = userService.getCurrentUser().cliente;
              }

              // const deveDistribuir =
              //   !isPontoAtendimento() && entidade.status === 'APROVADO';

              // if (deveDistribuir) {
              //   entidade.produtos = await this.preencherItensDistribuidos(
              //     entidade.produtos
              //   );
              // }

              entidade.produtos = produtosComQtdValida;

              const response = await pedidoEmMapaService.doSave(entidade); // AxiosResponse
              const salvo = response && response.data ? response.data : null;
              const numeroPedido =
                salvo && salvo.numeroPedido ? salvo.numeroPedido : null;
              this.props.history.push('/pedidoEmMapa');
              actions.setSubmitting(false);
              this.props.success({
                message: numeroPedido
                  ? `Mapa salvo. Nº do pedido: ${numeroPedido}.`
                  : 'Mapa de Produtos salvo com sucesso.',
              });

              this.props.loading(true);
            } catch (e) {
              console.error(e);
              actions.setSubmitting(false);
              this.props.loading(false);
              this.props.error({
                message: 'Erro ao salvar o pedido. Verifique os dados.',
              });
            }
          }}
        >
          {(formikProps) => {
            this.formikRef.current = formikProps;

            const {
              values,
              errors,
              touched,
              handleChange,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            } = formikProps;

            return (
              <form onSubmit={handleSubmit} noValidate>
                <div className="flex-column">
                  <Toast />
                  <div className="cardSeculus d-flex flex-column mb-0">
                    <div className="form-row">
                      {isSudo() && (
                        <div className="form-group col-md-6">
                          <FormSelectInput
                            disabled={isFinalizado}
                            name="cliente"
                            id="cliente"
                            label="Cliente"
                            placeholder="Selecione o cliente"
                            valueKey="codigoCliente"
                            labelKey="label"
                            required={true}
                            returnFullObject={true}
                            service={async () => {
                              const resp = await clienteService.findAll();
                              return {
                                data: (resp.data || []).filter((c) =>
                                  Boolean(c.possuiPontoAtendimento)
                                ),
                              };
                            }}
                            onChange={(name, value) => {
                              setFieldValue(name, value);
                              setFieldValue('pontoAtendimentoId', null);
                              setFieldValue('produtos', []);
                            }}
                            value={values.cliente}
                            messageValidate={touched.cliente && errors.cliente}
                          />
                        </div>
                      )}
                      {/* {Object.keys(errors).length > 0 && (
                      <pre style={{ color: 'red' }}>
                        {JSON.stringify(errors, null, 2)}
                      </pre>
                    )} */}
                      {(isSudo() || isAdmin() || isAprovador()) &&
                        values.cliente && (
                          <div className="form-group col-md-6">
                            <FormSelectInput
                              disabled={isFinalizado}
                              key={values.cliente.codigoCliente}
                              name="pontoAtendimentoId"
                              id="pontoAtendimentoId"
                              label="Ponto de Atendimento"
                              placeholder="Selecione o PA"
                              valueKey="id"
                              labelKey="nome"
                              required={true}
                              returnFullObject={false}
                              parent={values.cliente}
                              service={pontoAtendimentoService.findAllByCliente}
                              onChange={(name, value) => {
                                setFieldValue(name, value);
                                setFieldValue('produtos', []);
                                this.buscarMapaPorPA(value);
                              }}
                              value={values.pontoAtendimentoId}
                              messageValidate={errors.pontoAtendimentoId}
                            />
                          </div>
                        )}

                      {(isSudo() || isAdmin() || isAprovador()) && entity.id && (
                        <div className="form-group col-md-6">
                          <SelectInput
                            name="status"
                            id="status"
                            label="Status"
                            placeholder="Selecione o novo status"
                            valueKey="value"
                            labelKey="label"
                            noSize={true}
                            returnFullObject={false}
                            isMulti={false}
                            searchable={false}
                            allowSelectAll={false}
                            options={objectsConstants.STATUS_PEDIDO_DEVOLUCAO}
                            messageValidate={errors.status}
                            disabled={isFinalizado}
                            value={values.status}
                            className={`select-status ${values.status &&
                              values.status.toLowerCase()}`}
                            onChange={(name, value) => {
                              const statusAnterior = values.status;
                              const statusNovo = value;
                              const finalizando =
                                statusAnterior === 'CRIADO' &&
                                (statusNovo === 'APROVADO' ||
                                  statusNovo === 'RECUSADO');

                              if (finalizando) {
                                confirmAlert({
                                  customUI: ({ onClose }) => (
                                    <div className="custom-confirm-alert">
                                      <h2>Confirmação</h2>
                                      <p>
                                        Ao aprovar ou recusar, o pedido não
                                        poderá mais ser alterado. Deseja
                                        continuar?
                                      </p>
                                      <div className="d-flex justify-content-around mt-4">
                                        <button
                                          className="btn btn-secondary btn30 white"
                                          onClick={onClose}
                                        >
                                          Cancelar
                                        </button>
                                        <button
                                          className="btn btn-danger btn30"
                                          onClick={() => {
                                            setFieldValue(name, value);
                                            onClose();
                                          }}
                                        >
                                          Confirmar
                                        </button>
                                      </div>
                                    </div>
                                  ),
                                });
                              } else {
                                setFieldValue(name, value);
                              }
                            }}
                          />
                        </div>
                      )}
                      {(isSudo() || isAdmin() || isAprovador()) && (
                        <div className="form-group col-md-6">
                          <label className="label-nowrap">É urgente?</label>
                          <div>
                            <Switch
                              onChange={(value) =>
                                setFieldValue('urgente', value)
                              }
                              checked={values.urgente || false}
                              onColor={'#0080ff'}
                              offColor={'#d9d9d9'}
                              height={30}
                              width={60}
                              handleDiameter={28}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              activeBoxShadow={'none'}
                              disabled={isFinalizado}
                            />
                          </div>
                        </div>
                      )}
                      {values.status === 'RECUSADO' && (
                        <div className="form-group col-md-12">
                          <label htmlFor="justificativaRecusa">
                            Justificativa da Recusa
                          </label>
                          <textarea
                            className="form-control"
                            name="justificativaRecusa"
                            id="justificativaRecusa"
                            rows="3"
                            value={values.justificativaRecusa}
                            onChange={handleChange}
                            disabled={isFinalizado}
                          />
                        </div>
                      )}
                    </div>

                    {/* Filtro categoria */}
                    <div className="form-group">
                      <label className="mb-2">Categorias</label>
                      <div className="d-flex flex-wrap mb-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary mr-2 mb-2"
                          onClick={() =>
                            this.setState({
                              categoriasSelecionadas: this.state.categorias.map(
                                (c) => c.descricao
                              ),
                            })
                          }
                        >
                          Marcar todos
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary mb-2"
                          onClick={() =>
                            this.setState({ categoriasSelecionadas: [] })
                          }
                        >
                          Desmarcar todos
                        </button>
                      </div>
                      <div className="d-flex flex-wrap">
                        {this.state.categorias
                          .filter((cat) => cat.descricao !== '')
                          .map((cat) => (
                            <div key={cat.descricao} className="mr-3 mb-2">
                              <label>
                                <input
                                  type="checkbox"
                                  checked={this.state.categoriasSelecionadas.includes(
                                    cat.descricao
                                  )}
                                  onChange={(e) => {
                                    const {
                                      categoriasSelecionadas,
                                    } = this.state;
                                    if (e.target.checked) {
                                      this.setState({
                                        categoriasSelecionadas: [
                                          ...categoriasSelecionadas,
                                          cat.descricao,
                                        ],
                                      });
                                    } else {
                                      this.setState({
                                        categoriasSelecionadas: categoriasSelecionadas.filter(
                                          (c) => c !== cat.descricao
                                        ),
                                      });
                                    }
                                  }}
                                />{' '}
                                {cat.descricao}
                              </label>
                            </div>
                          ))}
                      </div>
                    </div>
                    {/* fim filtro categoria */}

                    <div className="lista-mapa-produto">
                      <table className="table table-bordered table-sm align-middle">
                        <thead className="thead-light">
                          <tr>
                            <th>Item</th>
                            <th>Código</th>
                            <th className="w-50">Descrição</th>
                            {!isPontoAtendimento() && <th>Estoque Total</th>}
                            <th>Categoria</th>
                            <th>Unidade Medida</th>
                            <th>Máximo</th>
                            <th className="w100">Estoque Atual</th>
                            <th className="w100">Solicitar</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(values.produtos || [])
                            .filter((p) => {
                              const familiaDesc =
                                (p.produto && p.produto.descricaoFamilia) ||
                                'Sem categoria';
                              return this.state.categoriasSelecionadas.includes(
                                familiaDesc
                              );
                            })

                            .map((item, index) => (
                              <tr key={index}>
                                <td className="text-center">{index + 1}</td>
                                <td>
                                  <span
                                    className={
                                      !item.temEstoque
                                        ? 'text-danger font-weight-bold'
                                        : ''
                                    }
                                  >
                                    {(item.produto &&
                                      item.produto.codigoProduto) ||
                                      'Não informado'}
                                  </span>
                                </td>
                                <td className="w-50">
                                  <span
                                    className={
                                      !item.temEstoque
                                        ? 'text-danger font-weight-bold'
                                        : ''
                                    }
                                  >
                                    {(item.produto && item.produto.descricao) ||
                                      'Não informado'}
                                  </span>
                                  {!item.temEstoque && (
                                    <span className="text-red">
                                      {' '}
                                      (Sem estoque)
                                    </span>
                                  )}
                                  {item.produto && item.produto.bloqueado && (
                                    <span className="text-red">
                                      {' '}
                                      (Produto Bloqueado)
                                    </span>
                                  )}
                                </td>
                                {!isPontoAtendimento() && (
                                  <td className="text-center">
                                    {item.estoqueTotal != null
                                      ? item.estoqueTotal
                                      : '-'}
                                  </td>
                                )}
                                <td>
                                  {(item.produto &&
                                    item.produto.descricaoFamilia) ||
                                    'Não Informado'}
                                </td>
                                <td className="text-center">
                                  {(item.produto &&
                                    item.produto.unidadeMedida) ||
                                    'Não informado'}
                                </td>
                                <td className="text-center">
                                  {item.limiteMaximo}
                                </td>
                                <td className="w100">
                                  <FormInput
                                    type="number"
                                    noSize
                                    erroMensagem={_.get(
                                      errors,
                                      `produtos[${index}].estoqueAtual`
                                    )}
                                    name={`produtos[${index}].estoqueAtual`}
                                    value={item.estoqueAtual}
                                    onChange={setFieldValue}
                                    disabled={
                                      isFinalizado ||
                                      (item.produto && item.produto.bloqueado)
                                    }
                                  />
                                </td>
                                <td className="w100">
                                  <FormInput
                                    type="number"
                                    noSize
                                    id={`produtos${index}qtdSolicitar`}
                                    erroMensagem={_.get(
                                      errors,
                                      `produtos[${index}].qtdSolicitar`
                                    )}
                                    name={`produtos[${index}].qtdSolicitar`}
                                    value={item.qtdSolicitar}
                                    onChange={setFieldValue}
                                    disabled={
                                      isFinalizado ||
                                      (item.produto &&
                                        item.produto.bloqueado) ||
                                      item.estoqueTotal === 0
                                    }
                                  />
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="form-row">
                      <div className="form-group col-md-6">
                        <FormInput
                          label="Responsável"
                          noSize
                          id="responsavel"
                          disabled={isFinalizado}
                          type="text"
                          name={`responsavel`}
                          value={values.responsavel}
                          onChange={setFieldValue}
                          erroMensagem={errors.responsavel}
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <CpfInput
                          placeholder="Digite o CPF"
                          erroMensagem={errors.cpfResponsavel}
                          id={'cpfResponsavel'}
                          name="cpfResponsavel"
                          value={values.cpfResponsavel}
                          onChange={setFieldValue}
                          noSize={true}
                          label={'CPF do responsável'}
                          disabled={isFinalizado}
                          required
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-row flex-sm-row ">
                      <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                        <button
                          type="button"
                          className="btn btn-secondary btn30 white"
                          disabled={isSubmitting}
                          onClick={() => this.props.history.goBack()}
                        >
                          Cancelar
                        </button>
                      </div>
                      {isEdit && (
                        <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                          <button
                            type="button"
                            className="btn btn-danger btn30"
                            disabled={isSubmitting || isFinalizado}
                            onClick={() => {
                              confirmAlert({
                                customUI: ({ onClose }) => (
                                  <div className="custom-confirm-alert">
                                    <h2>Confirmar exclusão</h2>
                                    <p>
                                      Você tem certeza que deseja excluir este
                                      Pedido em Mapa?
                                    </p>
                                    <div className="d-flex justify-content-around mt-4">
                                      <button
                                        className="btn btn-secondary btn30 white"
                                        onClick={onClose}
                                      >
                                        Não
                                      </button>
                                      <button
                                        className="btn btn-danger btn30"
                                        onClick={async () => {
                                          try {
                                            await pedidoEmMapaService.doDelete(
                                              values.id
                                            );
                                            this.props.success({
                                              message:
                                                'Pedido em mapa excluído com sucesso.',
                                            });
                                            this.props.history.push(
                                              '/pedidoEmMapa'
                                            );
                                            onClose();
                                          } catch (e) {
                                            console.error(e);
                                            this.props.error({
                                              message:
                                                'Erro ao excluir o Pedido em mapa',
                                            });
                                            onClose();
                                          }
                                        }}
                                      >
                                        Sim
                                      </button>
                                    </div>
                                  </div>
                                ),
                              });
                            }}
                          >
                            Excluir
                          </button>
                        </div>
                      )}

                      <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                        <button
                          type="submit"
                          className="btn btn-secondary btn30 green"
                          disabled={
                            isSubmitting ||
                            values.produtos.length === 0 ||
                            isFinalizado
                          }
                        >
                          {entity.id ? 'Salvar Alterações' : 'Salvar'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { load, message } = state.load;
  return { user, loading: load, messageLoading: message };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load, message = '') => loading({ load, message }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(
  mapStateToProps,
  mapDispatch,
  null,
  { forwardRef: true }
)(PedidoEmMapaEdit);
